export function isNotNil<X>(x: X | null | undefined): x is X {
  return x !== null && x !== undefined;
}
